import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';
import { helperReducer } from '../../reducers';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { IApplicationContext } from '../../index';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param preloadedState IApplicationState - предзагруженное состояние
 */

export function createReduxStore(
  preloadedState: IApplicationState,
  context: IApplicationContext,
  debugEnabled?: boolean,
) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    helper: helperReducer,
    abGroup: (state = 100) => state,
    userData: (state = null) => state,
    userGaData: (state = null) => state,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = () => _createStore(reducers, preloadedState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
